import { Tab } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { classNames } from "../../utils/Utils";
import Disclaimer from "./Disclaimer";
import PrivacyPolicy from "./PrivacyPolicy";
import RefundPolicy from "./RefundPolicy";
import TermsOfService from "./TermsOfService";

export default function PolicyPage({ defaultTab = "disclaimer" }) {
  function PolicyTab({ heading }) {
    return (
      <Tab
        key={heading}
        className={({ selected }) =>
          classNames(
            "font-bold leading-10",
            selected
              ? "text-primary-midBlack  text-2xl "
              : "text-[#848484] text-xl"
          )
        }
      >
        {heading}
      </Tab>
    );
  }

  return (
    <div className="flex flex-col w-full h-full bg-primary-midBlack">
      <div className="w-full  pt-20 pb-5 px-5 md:px-32">
        <a href="/">
          <p className="text-white font-bold flex flex-row items-center gap-1">
            <span>
              <Icon icon="ic:baseline-arrow-right-alt" className="rotate-180" />
            </span>
            Go back to the home page
          </p>
        </a>
      </div>
      <div className="bg-white w-full h-full px-5 md:px-32 py-10">
        <Tab.Group
          defaultIndex={
            defaultTab == "disclaimer"
              ? 0
              : defaultTab == "terms"
              ? 1
              : defaultTab == "privacy"
              ? 2
              : defaultTab == "refund"
              ? 3
              : 0
          }
        >
          <Tab.List className="flex space-x-6 font-poppins justify-start items-center pb-5 border-b-[1px] border-primary-midBlack border-opacity-50">
            <PolicyTab heading={"Disclaimer"} />
            <PolicyTab heading={"Terms & Conditions"} />
            <PolicyTab heading={"Privacy Policy"} />
            <PolicyTab heading={"Refund Policy"} />
          </Tab.List>
          <Tab.Panels>
            <Tab.Panel>
              <Disclaimer />
            </Tab.Panel>
            <Tab.Panel>
              <TermsOfService />
            </Tab.Panel>
            <Tab.Panel>
              <PrivacyPolicy />
            </Tab.Panel>
            <Tab.Panel>
              <RefundPolicy />
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}
